var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
/**
 * BranchViewEventModel defines event for racing braches.
 *
 * @typedef BranchViewEventModel
 * @type {Object}
 * @property {id} Unique identifier
 * @property {dateTime} Date of current Branch View event
 * @property {url} String seo url of current Branch View event
 * @property {title} Title ( starting time ) of current Branch View event
 * @property {racingStateId} ID of status for current Branch View event
 * @property {handler} Onclick handler of current BranchView Event
 */
export class BranchViewEventModel {
    constructor(source) {
        this.id = source.id;
        this.url = source.url;
        this.dateTime = source.dateTime;
        this.title = `${this.dateTime.formatDate("HH:mm")}`;
        this.raceProgress = source.raceProgress;
        this.handler = source.handler;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], BranchViewEventModel.prototype, "url", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], BranchViewEventModel.prototype, "raceProgress", void 0);
//# sourceMappingURL=BranchViewEventModel.js.map